import { paths } from "../routes/paths";

export const isTokenExpired = (status, message, navigate) => {
  if (status === 401 || message === "האדמין המבוקש לא קיים במערכת") {
    localStorage.removeItem("authToken");
    navigate(paths.login);
  }
};
